<template>
  <v-container class="pb-0">
    <v-row class="ma-0">
      <v-col cols="2">
        <!--Filters :props="filters"/-->
      </v-col>
      <v-col class="pa-0" cols="10">
        <div v-if="loading" class="px-3 pt-6">
          <v-row v-for="n in itemsPerPage" :key="n" class="mb-6">
            <v-col cols="3" class="pa-0">
              <v-skeleton-loader class="" type="image"></v-skeleton-loader>
            </v-col>
            <v-col cols="9" class="pa-0">
              <v-skeleton-loader height="150px" type="subtitle, paragraph"></v-skeleton-loader>
            </v-col>
          </v-row>
        </div>
        <v-row v-else>
          <div v-for="(item, index) in data" :key="index" style="width:calc(100%/4);">
            <v-card class="ma-6">
              
              <v-img :src="item.featured_image" height="220" cover/>

              <!-- Contenido -->
              <div class="pa-4">
                <!-- Precio -->
                <v-card-subtitle class="px-0">
                  {{$toCurrency(item.discount_price ?? item.price)}}
                  <span
                    v-if="item.discount_price != null"
                    class="text-caption text-red text-decoration-line-through ml-3"
                  >
                    {{$toCurrency(item.price)}}
                  </span>
                </v-card-subtitle>

                <!-- Título -->
                <v-card-title class="px-0">{{ item.title }}</v-card-title>

                <!-- Año, kilometraje, transmisión -->
                <v-card-subtitle class="text-grey pl-0">
                  {{ item.year }}
                  <span class="px-2">/</span>
                  {{ Number(item.mileage).toLocaleString('es-MX') + ' km' }}
                  <span class="px-2">/</span>
                  {{ item.transmission }}
                </v-card-subtitle>

                <!-- Sucursal -->
                <v-card-subtitle class="d-flex align-center text-caption mt-3 px-0">
                  <v-icon size="16" class="mr-1" color="grey">mdi-map-marker</v-icon>
                  {{ item.branch?.name }}
                </v-card-subtitle>
              </div>
            </v-card>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useLayoutStore } from '@/store/layout';
import { useLayoutField } from '@/composables/useLayoutField';
import Filters from '@/components/drawer/Filters.vue';

export default defineComponent({
  name: 'GridViewModule',
  components:{
    Filters
  },
  props: {
    moduleName: {
      type: String,
      required: true
    },
    data: Array,
    filters:Array
  },
  setup(props) {
    const layoutStore = useLayoutStore();
    const layout = layoutStore.getLayout(props.moduleName);

    const itemsPerPage = computed(() => layout.itemsPerPage);
    const loading = useLayoutField(props.moduleName, 'dataLoading');

    return {
      itemsPerPage,
      loading
    };
  }
});
</script>

